import React from 'react'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import MemberRepo from '../../../Repo/MemberRepo'
import {useParams} from 'react-router-dom'
import {useAsync} from 'react-use'
import {MBMemberError} from '../../../Common/MBMemberError'
import {CommonResponseStatus} from '../../../../Network/CommonResponse'

type MemberPasswordResetRedirectPageProps = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
}
export const MemberResetPasswordRedirectPage: React.VFC<MemberPasswordResetRedirectPageProps> = (
  props,
) => {
  const {oneTimeToken} = useParams<{ oneTimeToken: string }>()

  const resultGetVerifyIdentityInfo = useAsync(async () => {
    return await props.memberRepo.getVerifyIdentityInfo(oneTimeToken)
  })

  if (resultGetVerifyIdentityInfo.loading) {
    return <></>
  }

  if (resultGetVerifyIdentityInfo.error) {
    throw new MBMemberError('ServerError')
  }

  if (!resultGetVerifyIdentityInfo.value) {
    throw new MBMemberError('UnknownError')
  }

  switch (resultGetVerifyIdentityInfo.value.status) {
    case CommonResponseStatus.Ok:
      if (!resultGetVerifyIdentityInfo.value.data) {
        throw new MBMemberError('ServerError')
      }
      props.navigator.goToResetPasswordInputPage(
        oneTimeToken,
        {
          mail: resultGetVerifyIdentityInfo.value.data.mail,
          name: resultGetVerifyIdentityInfo.value.data.name,
          agreementList: resultGetVerifyIdentityInfo.value.data.agreementList,
        },
      )
      break
    case CommonResponseStatus.NotFound:
      throw new MBMemberError('NotFound')
    case CommonResponseStatus.Forbidden:
      throw new MBMemberError('InvalidOneTimeUrl')
    case CommonResponseStatus.InternalServerError:
      throw new MBMemberError('ServerError')
    default:
      throw new MBMemberError('UnknownError')
  }

  return null
}
